import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from "@angular/forms";
import { CustomerService } from '../_services/customer.service';
import { DebtorService } from '../_services/debtor.service';
import { MatSort, MatPaginator, MatTableDataSource } from '@angular/material';
import { ExcelService } from '../_helpers/index';
import { ICustomer, IAddress } from '../_models/customer.interface';
import { ParameterData } from '../_helpers/index';
import { Router } from '@angular/router';
import { DataService } from '../_helpers/dataservice.service'
import { AuthService } from '../_services/auth.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Debtor } from '../_models/index';
import * as XLSX from 'xlsx';
type AOA = any[][];

@Component({
  selector: 'customerimport',
  templateUrl: './customerimport.component.html',
  styleUrls: ['../../assets/css/customer-list-table.css']
})
export class CustomerImportComponent implements OnInit {

  customerPuplic_key: any;

  displayedColumns: string[] = ['external_id', 'document_type', 'document_id', 'name', 'email', 'phone', 'status', 'street', 'provice', 'city', 'district'];
  displayedColumnsProcessed: string[] = ['external_id', 'document_type', 'document_id', 'name', 'email', 'phone', 'status', 'street', 'provice', 'city', 'district'];

  dataSource = new MatTableDataSource();
  dataSourceProcessed = new MatTableDataSource();
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  data: any;
  excelHeader: any;
  uploadedFileName: any;

  tab1ActiveStatus: any;
  tab2ActiveStatus: any;
  tab3ActiveStatus: any;
  tab1Visibility: any;
  tab2Visibility: any;
  tab3Visibility: any;
  tab3ErrorVisibility: any;

  excelRowsFetchedCount: any;
  excelRowsProcessedCount: any;
  excelRowsNotProcessedCount: any;
  processStatus: any;
  processStatusText: any;
  enableImportExcel: boolean;
  errorCustomerExport: any;
  errorstatus: any;

  public arrFinalData = [];
  public arrFinalStatusWithData = [];
  specialCharValid = "/^[A-Za-z0-9áéíóúüñ¿¡ÁÉÍÓÚÜÑ\ &#,.\'-]+$/";
  constructor
    (
      private customerService: CustomerService, private formBuilder: FormBuilder
      , private excelService: ExcelService, private parameterData: ParameterData
      , private router: Router, private debtorService: DebtorService
      , private dataService: DataService
      , private auth: AuthService
      , private spinnerService: Ng4LoadingSpinnerService

    ) {

  }//end const


  ngOnInit() {

    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
    if (browserStorage1 == null) {
      let browserStorage = localStorage.getItem('companyId');
      if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
        this.router.navigate(['/home']);
      }
      else {
        this.customerPuplic_key = localStorage.getItem('companyId');
      }
    }
    else {
      this.customerPuplic_key = localStorage.getItem('subcompanyId');
    }

    this.enableImportExcel = false;
    this.tab1ActiveStatus = "active";
    this.tab2ActiveStatus = "disabled";
    this.tab3ActiveStatus = "disabled";
    this.tab1Visibility = true;
    this.tab2Visibility = false;
    this.tab3Visibility = false;
    this.tab3ErrorVisibility = false;
    this.uploadedFileName = "Archivo a subir";

    this.excelRowsFetchedCount = Number(0);
    this.excelRowsProcessedCount = Number(0);
    this.excelRowsNotProcessedCount = Number(0);

  }//end ngoninit




  onFileChange(evt: any) {

    this.enableImportExcel = true;
    this.spinnerService.show();

    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(evt.target);

    if (target.files.length !== 1 && evt.target.accept !== ".xlsx") throw new Error('Cannot use multiple files');
    this.uploadedFileName = target.files[0].name;
    if (target.files.length == 1 && (target.files[0].type == ".xlsx" || target.files[0].type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || target.files[0].type == "application/vnd.ms-excel")) {
      this.uploadedFileName = target.files[0].name;
      const reader: FileReader = new FileReader();
      reader.onload = (e: any) => {
        /* read workbook */
        const bstr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

        /* grab first sheet */
        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];

        /* save data */
        
        this.data = (XLSX.utils.sheet_to_json(ws, { header: 1 }));

      };
      reader.readAsBinaryString(target.files[0]);
    }
    else {
      this.enableImportExcel = false;
      this.errorCustomerExport = "Error al intentar abrir el archivo ! ";

    }
    this.spinnerService.hide();
  }//end onfilechange



  importExcelData() {

    this.spinnerService.show();


    this.excelHeader = this.data[0];
    var jsonObjectKeys = ['external_id', 'document_type', 'document_id', 'name', 'email', 'phone', 'status', 'street', 'provice', 'city', 'district'];

    if (this.excelHeader.length == 11) {
      if (this.data.length <= 1000) {


        for (var i = 1; i <= this.data.length - 1; i++) {
          var object_temp = {};
          for (var j = 0; j < this.excelHeader.length; j++) {

            object_temp[jsonObjectKeys[j]] = this.data[i][j];
          }//end for j
          this.arrFinalData.push(object_temp);
        }//end for i



        this.excelRowsFetchedCount = this.data.length - 1;
        this.dataSource.data = this.arrFinalData;
        this.dataSourceProcessed.data = this.arrFinalData;

        this.tab1Visibility = false;
        this.tab2Visibility = true;
        this.tab3Visibility = false;
        this.tab1ActiveStatus = "disabled";
        this.tab2ActiveStatus = "active";
        this.tab3ActiveStatus = "disabled";

        this.spinnerService.hide();
      }
      else {
        this.errorCustomerExport = "LIMITE MAXIMO A IMPORTAR SON 1000 REGISTROS";
      }
    }
    else {
      this.tab1Visibility = false;
      this.tab2Visibility = false;
      this.tab3Visibility = true;
      this.tab1ActiveStatus = "disabled";
      this.tab2ActiveStatus = "disabled";
      this.tab3ActiveStatus = "active";
      this.tab3ErrorVisibility = true;

    }
  }//end onfilechange


  Executeagain() {
    this.tab1Visibility = true;
    this.tab2Visibility = false;
    this.tab3Visibility = false;
    this.tab1ActiveStatus = "active";
    this.tab2ActiveStatus = "disabled";
    this.tab3ActiveStatus = "disabled";
    this.tab3ErrorVisibility = false;
    this.uploadedFileName = '';
  }

  confirmData() {

    this.spinnerService.show();

    for (var i = 0; i <= this.arrFinalData.length - 1; i++) {
      this.createDebtor(this.arrFinalData[i], i);
    }//end for


    this.tab1Visibility = false;
    this.tab2Visibility = false;
    this.tab3Visibility = true;
    this.tab1ActiveStatus = "disabled";
    this.tab2ActiveStatus = "disabled";
    this.tab3ActiveStatus = "active";
    this.tab3ErrorVisibility = false;
    window.scroll(0, 0);

    this.spinnerService.hide();

  }//end confirm Data




  createDebtor(arrFinalData: any, iVal) {
    var debtorObj = {} as Debtor;

    var customerObj = {} as ICustomer;
    var addressObj = {} as IAddress;

    var testEmail = this.arrFinalData[iVal].email;
    testEmail = (this.arrFinalData[iVal].email === undefined) ? "" : this.arrFinalData[iVal].email;

    var name = this.arrFinalData[iVal].name;
    var street = this.arrFinalData[iVal].street;
    var provice = this.arrFinalData[iVal].provice;
    var city = this.arrFinalData[iVal].city;
    var district = this.arrFinalData[iVal].district;


    if ((/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(testEmail)) &&
      (/^[A-Za-z0-9áéíóúüñ¿¡ÁÉÍÓÚÜÑ\ &#,.\'-]+$/.test(name)) &&
      (/^[A-Za-z0-9áéíóúüñ¿¡ÁÉÍÓÚÜÑ\ &#,.\'-]+$/.test(street)) &&
      (/^[A-Za-z0-9áéíóúüñ¿¡ÁÉÍÓÚÜÑ\ &#,.\'-]+$/.test(provice)) &&
      (/^[A-Za-z0-9áéíóúüñ¿¡ÁÉÍÓÚÜÑ\ &#,.\'-]+$/.test(city)) &&
      (/^[A-Za-z0-9áéíóúüñ¿¡ÁÉÍÓÚÜÑ\ &#,.\'-]+$/.test(district)) &&
      (this.arrFinalData[iVal].name.length <= 50)) {


      if (this.arrFinalData[iVal].phone === undefined) {

        debtorObj.document_id = (this.arrFinalData[iVal].document_id === undefined) ? ' ' : this.arrFinalData[iVal].document_id.toString();
        debtorObj.document_type = (this.arrFinalData[iVal].document_type === undefined) ? ' ' : this.arrFinalData[iVal].document_type.toString();
        debtorObj.email = (this.arrFinalData[iVal].email === undefined) ? ' ' : this.arrFinalData[iVal].email.toString();
        debtorObj.external_id = (this.arrFinalData[iVal].external_id === undefined) ? ' ' : this.arrFinalData[iVal].external_id.toString();
        debtorObj.name = (this.arrFinalData[iVal].name === undefined) ? ' ' : this.arrFinalData[iVal].name.toString();
        debtorObj.phone = (this.arrFinalData[iVal].phone === undefined) ? ' ' : this.arrFinalData[iVal].phone.toString();


        debtorObj.status = (this.arrFinalData[iVal].status === undefined) ? ' ' : this.arrFinalData[iVal].status.toString();

        customerObj.public_id = this.customerPuplic_key;
        debtorObj.creditor = customerObj;

        addressObj.city = (this.arrFinalData[iVal].city === undefined) ? ' ' : this.arrFinalData[iVal].city.toString();
        addressObj.street = (this.arrFinalData[iVal].street === undefined) ? ' ' : this.arrFinalData[iVal].street.toString();
        addressObj.county = (this.arrFinalData[iVal].provice === undefined) ? ' ' : this.arrFinalData[iVal].provice.toString();
        addressObj.state = (this.arrFinalData[iVal].district === undefined) ? ' ' : this.arrFinalData[iVal].district.toString();


        debtorObj.address = addressObj;


        this.debtorCreatePromiseFailProcess([debtorObj, iVal], [debtorObj, iVal])
      }
      else {
        debtorObj.document_id = (this.arrFinalData[iVal].document_id === undefined) ? ' ' : this.arrFinalData[iVal].document_id.toString();
        if (this.arrFinalData[iVal].document_type == 'OTROS' || this.arrFinalData[iVal].document_type == 'OTHER') {
          debtorObj.document_type = "OTHER";
        }
        else {
          debtorObj.document_type = (this.arrFinalData[iVal].document_type === undefined) ? ' ' : this.arrFinalData[iVal].document_type.toString();
        }

        debtorObj.email = (this.arrFinalData[iVal].email === undefined) ? ' ' : this.arrFinalData[iVal].email.toString();
        debtorObj.external_id = (this.arrFinalData[iVal].external_id === undefined) ? ' ' : this.arrFinalData[iVal].external_id.toString();
        debtorObj.name = (this.arrFinalData[iVal].name === undefined) ? ' ' : this.arrFinalData[iVal].name.toString();
        debtorObj.phone = (this.arrFinalData[iVal].phone === undefined) ? ' ' : this.arrFinalData[iVal].phone.toString();



        debtorObj.status = (this.arrFinalData[iVal].status === undefined) ? ' ' : this.arrFinalData[iVal].status.toString();

        customerObj.public_id = this.customerPuplic_key;
        debtorObj.creditor = customerObj;

        addressObj.city = (this.arrFinalData[iVal].city === undefined) ? ' ' : this.arrFinalData[iVal].city.toString();
        addressObj.street = (this.arrFinalData[iVal].street === undefined) ? ' ' : this.arrFinalData[iVal].street.toString();
        addressObj.county = (this.arrFinalData[iVal].provice === undefined) ? ' ' : this.arrFinalData[iVal].provice.toString();
        addressObj.state = (this.arrFinalData[iVal].district === undefined) ? ' ' : this.arrFinalData[iVal].district.toString();


        debtorObj.address = addressObj;

        const debtorCreatePromiseResult = this.debtorService.createDebtorPromise(debtorObj);

        debtorCreatePromiseResult.then(

          this.debtorCreatePromiseResultProcess.bind(this, [debtorObj, iVal])

        )
          .catch(error => {


          });

      }

    }
    else {
      debtorObj.document_id = (this.arrFinalData[iVal].document_id === undefined) ? ' ' : this.arrFinalData[iVal].document_id.toString();
      debtorObj.document_type = (this.arrFinalData[iVal].document_type === undefined) ? ' ' : this.arrFinalData[iVal].document_type.toString();
      debtorObj.email = (this.arrFinalData[iVal].email === undefined) ? ' ' : this.arrFinalData[iVal].email.toString();
      debtorObj.external_id = (this.arrFinalData[iVal].external_id === undefined) ? ' ' : this.arrFinalData[iVal].external_id.toString();
      debtorObj.name = (this.arrFinalData[iVal].name === undefined) ? ' ' : this.arrFinalData[iVal].name.toString();
      debtorObj.phone = (this.arrFinalData[iVal].phone === undefined) ? ' ' : this.arrFinalData[iVal].phone.toString();



      debtorObj.status = (this.arrFinalData[iVal].status === undefined) ? ' ' : this.arrFinalData[iVal].status.toString();

      customerObj.public_id = this.customerPuplic_key;
      debtorObj.creditor = customerObj;

      addressObj.city = (this.arrFinalData[iVal].city === undefined) ? ' ' : this.arrFinalData[iVal].city.toString();
      addressObj.street = (this.arrFinalData[iVal].street === undefined) ? ' ' : this.arrFinalData[iVal].street.toString();
      addressObj.county = (this.arrFinalData[iVal].provice === undefined) ? ' ' : this.arrFinalData[iVal].provice.toString();
      addressObj.state = (this.arrFinalData[iVal].district === undefined) ? ' ' : this.arrFinalData[iVal].district.toString();


      debtorObj.address = addressObj;
      this.errorstatus = "";

      if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(testEmail)) {
        this.errorstatus = "correo electrónico"
      }
      if (!/^[A-Za-z0-9áéíóúüñ¿¡ÁÉÍÓÚÜÑ\ &#,.\'-]+$/.test(name) || (this.arrFinalData[iVal].name.length >= 50)) {
        this.errorstatus = this.errorstatus + ', ' + " nombre"
      }
      if (!/^[A-Za-z0-9áéíóúüñ¿¡ÁÉÍÓÚÜÑ\ &#,.\'-]+$/.test(street)) {
        this.errorstatus = this.errorstatus + ', ' + " calle"
      }
      if (!/^[A-Za-z0-9áéíóúüñ¿¡ÁÉÍÓÚÜÑ\ &#,.\'-]+$/.test(provice)) {
        this.errorstatus = this.errorstatus + ', ' + " provice"
      }
      if (!/^[A-Za-z0-9áéíóúüñ¿¡ÁÉÍÓÚÜÑ\ &#,.\'-]+$/.test(city)) {
        this.errorstatus = this.errorstatus + ', ' + " ciudad"
      }
      if (!/^[A-Za-z0-9áéíóúüñ¿¡ÁÉÍÓÚÜÑ\ &#,.\'-]+$/.test(district)) {
        this.errorstatus = this.errorstatus + ', ' + " distrito"
      }

      this.debtorCreatePromiseFailProcessEmailFormat([debtorObj, iVal], [debtorObj, iVal], "please enter the valid" + this.errorstatus.replace(/^,|,$/g, ''))
    }


  }//end bindInvoiceDetails


  debtorCreatePromiseResultProcess(arrparams: any, createddebtor: any) {

    var iTmp = arrparams[1];

    var jsonObjectKeysStatus = ['external_id', 'document_type', 'document_id', 'name', 'email', 'phone', 'status', 'street', 'provice', 'city', 'district', 'processStatus', 'processStatusText']
    var object_tempStatus = {};


    if (createddebtor.status.toString() == "200") {

      if (createddebtor.body.Error == "500") {
        this.excelRowsNotProcessedCount = this.excelRowsNotProcessedCount + 1;
        this.processStatusText = createddebtor.body.Description;
        this.processStatus = "NO";
      }
      else {
        this.excelRowsNotProcessedCount = this.excelRowsNotProcessedCount + 1;
        this.processStatusText = "Cliente con ese email o código ya existe";
        this.processStatus = "NO";
      }


      for (var i = 0; i < this.excelHeader.length; i++) {
        if (i == this.excelHeader.length - 1) {
          object_tempStatus[jsonObjectKeysStatus[i]] = this.data[iTmp + 1][i];
          object_tempStatus["processStatus"] = this.processStatus;
          object_tempStatus["processStatusText"] = this.processStatusText;
        }
        else {
          object_tempStatus[jsonObjectKeysStatus[i]] = this.data[iTmp + 1][i];
        }
      }//end for i

    }
    else if (createddebtor.status.toString() == "201") {
      this.excelRowsProcessedCount = this.excelRowsProcessedCount + 1;
      this.processStatusText = "La información fue grabada correctamente !";
      this.processStatus = "SI";

      for (var j = 0; j < this.excelHeader.length; j++) {
        if (j == this.excelHeader.length - 1) {
          object_tempStatus[jsonObjectKeysStatus[j]] = this.data[iTmp + 1][j];
          object_tempStatus["processStatus"] = this.processStatus;
          object_tempStatus["processStatusText"] = this.processStatusText;
        }
        else {
          object_tempStatus[jsonObjectKeysStatus[j]] = this.data[iTmp + 1][j];
        }
      }//end for j
    }






    this.arrFinalStatusWithData.push(object_tempStatus);





  }//end debtorCreatePromiseResultProcess


  debtorCreatePromiseFailProcess(arrparams: any, createddebtor: any) {

    var iTmp = arrparams[1];

    var jsonObjectKeysStatus = ['external_id', 'document_type', 'document_id', 'name', 'email', 'phone', 'status', 'street', 'provice', 'city', 'district', 'processStatus', 'processStatusText']
    var object_tempStatus = {};




    this.excelRowsNotProcessedCount = this.excelRowsNotProcessedCount + 1;
    this.processStatusText = "Se requiere numero de telefono";
    this.processStatus = "NO";




    for (var k = 0; k < this.excelHeader.length; k++) {
      if (k == this.excelHeader.length - 1) {
        object_tempStatus[jsonObjectKeysStatus[k]] = this.data[iTmp + 1][k];
        object_tempStatus["processStatus"] = this.processStatus;
        object_tempStatus["processStatusText"] = this.processStatusText;
      }
      else {
        object_tempStatus[jsonObjectKeysStatus[k]] = this.data[iTmp + 1][k];
      }
    }//end for k




    this.arrFinalStatusWithData.push(object_tempStatus);





  }//end debtorCreatePromiseResultProcess

  debtorCreatePromiseFailProcessEmailFormat(arrparams: any, createddebtor: any, processStatus: any) {

    var iTmp = arrparams[1];

    var jsonObjectKeysStatus = ['external_id', 'document_type', 'document_id', 'name', 'email', 'phone', 'status', 'street', 'provice', 'city', 'district', 'processStatus', 'processStatusText']
    var object_tempStatus = {};




    this.excelRowsNotProcessedCount = this.excelRowsNotProcessedCount + 1;

    this.processStatusText = processStatus;
    this.processStatus = "NO";




    for (var j = 0; j < this.excelHeader.length; j++) {
      if (j == this.excelHeader.length - 1) {
        object_tempStatus[jsonObjectKeysStatus[j]] = this.data[iTmp + 1][j];
        object_tempStatus["processStatus"] = this.processStatus;
        object_tempStatus["processStatusText"] = this.processStatusText;
      }
      else {
        object_tempStatus[jsonObjectKeysStatus[j]] = this.data[iTmp + 1][j];
      }
    }//end for j




    this.arrFinalStatusWithData.push(object_tempStatus);





  }//end debtorCreatePromiseResultProcess


  downloadResultAsXLSX() {
    this.setExportExcelFileData(this.arrFinalStatusWithData);
  }//end





  setExportExcelFileData(excelExportData) {
    var excelHeader = ["ID CLIENTE", "DOCUMENTO", "NUMERO DOCUMENTO", "NOMBRE", "EMAIL", "TELEFONO", "ESTADO", "CALLE", "PROVINCIA", "CIUDAD", "DISTRITO", "PROCESADO", "PROCESESTADO"]
    var jsonObjectKeys = ['external_id', 'document_type', 'document_id', 'name', 'email', 'phone', 'status', 'street', 'provice', 'city', 'district', 'processStatus', 'processStatusText']

    var arrFinalData = [];
    var object_temp = {};
    var i = 0;
    var columnsKeyNames = [];

    for (i = 0; i < excelExportData.length; i++) {
      var singleRec_temp = excelExportData[i];
      delete singleRec_temp['public_id'];

      columnsKeyNames = Object.keys(singleRec_temp);

      object_temp = {};

      for (var j = 0; j < columnsKeyNames.length; j++) {

        object_temp[excelHeader[j]] = singleRec_temp[jsonObjectKeys[j]];

      }
      arrFinalData.push(object_temp);
    }

    this.excelService.exportAsExcelFile(arrFinalData, 'ImportedCustomerList');


  }//end function



















}//end class